<template>
  <div class="container">
    <div v-if="!isMobile" class="pcWrapper">
      <div class="relationsWrapper">
        <div class="bannerWrapper">
          <img src="https://img.i2soft.net/i2official-web/v2/assets/images/dynamic/cmpDynamicBg.png" />
        </div>
        <div class="mapWrapper">
          <div style="width: 80%; position: relative; margin: 0 auto">
            <div class="annoce_box">
              <div class="inner-tit center gray">
                <div class="secontTitle">
                  <WaveTitle :title="'公司动态'" :subhead="'Dynamic state'"></WaveTitle>
                </div>
              </div>

              <!-- 添加无数据状态 -->
              <div v-if="dynamicList.length === 0 && !loading" class="no-data-state">
                <el-empty description="暂无公司动态数据"> </el-empty>
              </div>

              <div v-else>
                <div class="annonce_borderv2" v-for="(dyn, index) in dynamicList" :key="dyn.id">
                  <a @click="innerDynamicClick(dyn)" class="Allv2">
                    <div class="annonceIn">
                      <div class="annonceInLeft">
                        <span class="num">{{ formatIndex(index) }}</span>
                      </div>
                      <div class="annonceInRight">
                        <div class="cell_v2">
                          <h3 class="h3_v2">{{ dyn.title }}</h3>
                          <div class="info_v2">
                            {{ dyn && dyn.articleSource === "site" ? `https://www.i2finance.net/#/internal?dynId=${dyn.id}` : dyn.articleUrl }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>

                <!-- 分页 -->
                <div class="pagination-wrapper" v-if="page.total > page.pageSize">
                  <el-pagination background @current-change="handlePageChange" :current-page="page.currentPage" :page-size="page.pageSize" layout="prev, pager, next" :total="page.total"> </el-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import WaveTitle from "@/components/WaveTitle.vue";
  import { isMobile } from "@/utils/index";
  import { useGetDynamicListApi } from "@/api/useDynamicApi";
  export default {
    components: { WaveTitle },
    data() {
      return {
        isMobile: false,
        keyWords: "",
        dynamicList: [],
        loading: true, // 添加加载状态
        // 分页信息
        page: {
          total: 0,
          currentPage: 1,
          pageSize: 20, // 每页20条
        },
      };
    },
    created() {
      this.getData();
    },
    mounted() {
      this.isMobile = isMobile();
      window.addEventListener("scroll", this.getScroll);
    },
    destroyed() {
      window.removeEventListener("scroll", this.getScroll);
    },
    methods: {
      //获取数据并处理
      async getData() {
        this.loading = true;
        try {
          const res = await useGetDynamicListApi({
            pageNum: this.page.currentPage,
            pageSize: this.page.pageSize,
          });
          if (res) {
            this.dynamicList = res.records || [];
            this.page.total = res.total || 0;
            this.page.currentPage = res.current || 1;
          }
        } catch (error) {
          console.error("获取公司动态数据失败:", error);
          this.dynamicList = [];
        } finally {
          this.loading = false;
        }
      },

      // 处理分页变化
      async handlePageChange(newPage) {
        this.page.currentPage = newPage;
        await this.getData();
        // 回到顶部
        window.scrollTo(0, 540);
      },

      // 格式化序号，个位数前面补0
      formatIndex(index) {
        const num = index + 1;
        return num < 10 ? `0${num}` : num.toString();
      },

      // 切换tab
      handleClick(tab, event) {
        console.log(tab, event);
      },

      // 点击内部动态链接
      innerDynamicClick(v) {
        if (!v) {
          return;
        }
        // 如果是外部动态，直接跳转
        if (v.articleUrl && v.articleSource === "external") {
          window.open(v.articleUrl, "_blank");
          return;
        }
        // 内部文章跳转到详情页，传递id
        this.$router.push({
          path: "/internal",
          query: { dynId: v?.id },
        });
      },

      getScroll() {
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if (!!document.documentElement.scrollTop && document.documentElement.scrollTop >= 70) {
          this.$store.commit("TO_AfterScroll");
        } else {
          this.$store.commit("TO_AfterScroll_false");
        }
      },
    },
  };
</script>

<style lang="less" scoped>
  * {
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .relationsWrapper {
    background-color: #ffffff;

    .bannerWrapper {
      width: 100%;
      position: relative;

      img {
        width: 100%;
        height: 100%;
      }

      .bannerTextWrapper {
        position: absolute;
        top: 45%;
        left: 5%;
        display: flex;
        flex-direction: column;

        .bannerText1 {
          font-family: Source Han Serif CN;
          font-size: 72px;
          font-weight: 900;
          line-height: normal;
          letter-spacing: 0em;
          text-align: left;
          color: #006291;
        }

        .bannerText2 {
          font-family: AlibabaPuHuiTi;
          font-size: 36px;
          font-weight: normal;
          line-height: normal;
          letter-spacing: 0em;
          text-align: left;
          color: #296995;
        }

        .bannerText3 {
          color: rgba(255, 255, 255, 100);
          font-size: 25px;
          text-align: left;
          font-family: PingFangSC-Light;
        }
      }
    }

    .announcementWrapper {
      .top_box {
        background-color: rgba(246, 246, 246, 1);
        position: relative;
        padding: 1px 0px;
        height: 50px;
        top: -6px;
      }
    }

    .mapWrapper {
      display: flex;
      flex-direction: column;
      margin: auto;
      padding: 0px;

      .annoce_box {
        margin-bottom: 20px;
        margin-top: 20px;
        width: 100%;
        height: 100%;

        .center {
          text-align: center;

          h3 {
            color: #333333;
            font-size: 26px;
          }
        }

        .annonce_border {
          background-color: rgba(242, 243, 242, 1);
          margin-top: 10px;
        }

        .annonce_border .All {
          display: flex;
          width: 100%;
          text-decoration: none;
          color: #333;
          margin: 0;
          padding: 0;
        }

        .All:link {
          a {
            color: rgba(37, 94, 162, 100);
          }
        }

        .All:visited {
          a {
            color: rgba(37, 94, 162, 100);
          }
        }

        .All:hover {
          a {
            content: "";
            color: #fff;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(53, 135, 195, 1);
          }
        }

        .left_box {
          width: 120px;
          height: 120px;
          padding: 20px;
          position: relative;

          .date_box {
            margin-top: 10px;
            margin-left: 10px;

            .num {
              font-size: 40px;
              margin-bottom: 10px;
              font-family: "ziticqtezhanti";
            }
          }
        }

        .right_box {
          width: calc(100% - 122px);
          margin-left: 2px;
          position: relative;
          padding: 0 0 0 3.125vw;
        }

        .left_box i {
          font-style: normal;
          font-size: 40px;
          line-height: 1;
          font-family: "ziticqtezhanti";
          display: block;
          position: relative;
          transition: color 0.3s ease;
        }

        .left_box span {
          position: absolute;
          left: 20px;
          right: 20px;
          bottom: 20px;
          font-size: 18px;
          font-family: "NeutraTextLight";
          transition: color 0.3s ease;
        }

        .content_box {
          background-color: #fff;
          width: 0.5vw;
        }

        .cell_box {
          height: 100%;
          position: relative;
          text-align: left;
          margin-top: 1.5%;
          display: flex;
        }

        .cell_box .cell {
          width: 75%;
          display: inline-block;
          vertical-align: middle;
        }

        .h3 {
          font-size: 15px;
          transition: color 0.3s ease;
        }

        .info {
          font-size: 80%;
          margin-bottom: 15px;
          color: rgba(37, 125, 159, 100);
        }

        .cell_box .cell span {
          margin-right: 20px;
        }

        .pdf_img {
          width: 20%;
          height: 100%;
          position: relative;
          margin-right: 3%;
          text-align: right;
        }

        .pdf_img img {
          width: 50px;
          height: 50px;
        }

        .annonce_borderv2 {
          background-color: rgba(242, 243, 242, 1);
          margin-top: 10px;
          padding: 22px;
          cursor: pointer;
        }

        .annonce_borderv2:hover {
          background-image: url("https://img.i2soft.net/i2official-web/v2/assets/images/dynamic/jhk.png");
          background-size: cover;
          background-repeat: no-repeat;

          .Allv2 {
            .annonceIn {
              .annonceInLeft {
                background: #f3d8b8;
                font-weight: 700;

                .num {
                  font-size: 38px;
                  font-weight: 700;
                }
              }
            }
          }
        }

        .annonce_borderv2 .Allv2 {
          display: flex;
          width: 100%;
          text-decoration: none;
          color: #333;
          margin: 0;
          padding: 0;
        }

        .annonceIn {
          display: flex;

          .annonceInLeft {
            width: 106px;
            height: 114px;
            background-image: url("https://img.i2soft.net/i2official-web/v2/assets/images/dynamic/mask_group.png");
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            display: flex;
            justify-content: center;
            align-items: center;

            .num {
              font-size: 38px;
              color: #1c1e50;
            }
          }

          .annonceInRight {
            margin-left: 25px;

            .cell_v2 {
              .h3_v2 {
                font-size: 24px;
                transition: color 0.3s ease;
                font-weight: bold;
                text-align: left;
                color: #383838;
              }

              .info_v2 {
                text-align: left;
                font-size: 20px;
                margin-bottom: 15px;
                color: #f49a42;
              }
            }
          }
        }
      }

      // 分页样式
      .pagination-wrapper {
        display: flex;
        justify-content: center;
        margin-top: 30px;
        margin-bottom: 30px;
      }

      // 添加无数据状态样式
      .no-data-state {
        text-align: center;
        padding: 50px 0;
        color: #999;
        font-size: 16px;
      }
    }
  }

  .dynamicTopBg {
    background-image: url("https://img.i2soft.net/i2official-web/v2/assets/images/dynamic/cmpDynamicBg.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 926px;
  }
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #f49a42;
    color: #fff;
  }

  /deep/.el-input__prefix {
    display: flex;
  }

  /deep/.el-input__inner::placeholder {
    color: #f49a42;
    opacity: 1;
  }

  /deep/.el-input__inner:-ms-input-placeholder {
    color: #f49a42;
  }

  /deep/.el-input__inner::-webkit-input-placeholder {
    color: #f49a42;
  }
</style>
